import { render, staticRenderFns } from "./systemCorporateAccount.vue?vue&type=template&id=ecf8dd26&scoped=true"
import script from "./systemCorporateAccount.vue?vue&type=script&lang=js"
export * from "./systemCorporateAccount.vue?vue&type=script&lang=js"
import style0 from "./systemCorporateAccount.vue?vue&type=style&index=0&id=ecf8dd26&prod&scoped=true&lang=css"
import style1 from "./systemCorporateAccount.vue?vue&type=style&index=1&id=ecf8dd26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf8dd26",
  null
  
)

export default component.exports